import React from "react";
import { Box, useTheme } from "@mui/material";
import { AccountTypeEnum } from "@rentablo/api/apiv1";
import RefIcon from "@icons/myicons/arrow-down-right.svg?react";
import { accountTypeIconMapper, hasDefaultIcon } from "@icons/utils";
import { BankAvatar } from "@rentablo/components";
import IconBox from "./IconBox";

interface AccountPreviewIconProps {
  isReference: boolean;
  iconUrl: string;
  type: AccountTypeEnum;
  size?: number;
  hideRefIcon?: boolean;
  iconSize?: number;
  bgColor?: string;
}

const AccountPreviewIcon = ({
  isReference,
  iconUrl,
  type,
  size = 48,
  iconSize,
  hideRefIcon = false,
  bgColor,
}: AccountPreviewIconProps) => {
  const theme = useTheme();
  const refIconSize = `${size * 0.625}px`;
  const commonBoxStyles = {
    width: `${size}px`,
    height: `${size}px`,
    display: "flex",
    alignItems: "center",
  };

  if (isReference) {
    if (hideRefIcon && hasDefaultIcon(iconUrl)) {
      return <IconBox size={size}>{accountTypeIconMapper["01_depot"]}</IconBox>;
    } else if (hideRefIcon) {
      return <BankAvatar imgUrl={iconUrl} size={size} />;
    }
    return (
      <Box
        sx={{
          ...commonBoxStyles,
          color: theme.palette.icon.tertiary,
          justifyContent: "initial",
          "& svg": {
            width: refIconSize,
            height: refIconSize,
          },
        }}
      >
        <RefIcon width={`${size}px`} height={`${size}px`} />
      </Box>
    );
  }

  if (!hasDefaultIcon(iconUrl)) {
    return <BankAvatar imgUrl={iconUrl} size={size} />;
  }

  return (
    <IconBox size={size} iconSize={iconSize} bgColor={bgColor}>
      {accountTypeIconMapper[type]}
    </IconBox>
  );
};

export default AccountPreviewIcon;
